App.filter('getDateFromBirthdate', function () {
    return function (date) {
        date = date || '';
        if (date) {
        	var preciseDate = new Date(date);
            var formattedDate = moment(preciseDate).format('YYYY-MM-DD');

        	return formattedDate;
        } else {
        	return null;
        }
        return null;
    };
});